import { css } from "styled-components";

export const border = css`
  border-radius: 255px 15px 225px 15px / 15px 255px 15px;
  border: 2px solid #41403e;
`;
